import ChartSkeletonLoader from "pages/PanelPage/components/charts/ChartSkeletonLoader/ChartSkeletonLoader";

export default ChartSkeletonLoader;
